module.exports = __webpack_public_path__ + "img/luthi-9.4ca8c104.jpg";